export class GlobalIndustrySegments {
    globalIndustrySegmentId: number;
    name: string;
}

export class CO2MapBySapPlantReportFilters {
    SiteIdArray: number[];
    globalIndustrySegmentIDArray: number[];
    canCrossBorders: boolean;
    miles: number;
    constructor(sitearr, segarr, cancross, miles) {
        this.SiteIdArray = sitearr;
        this.globalIndustrySegmentIDArray = segarr;
        this.canCrossBorders = cancross;
        this.miles = miles;
    }
}

export class CO2MapBySapPlantReportAllData {
    cO2MapBySapPlantReportList: CO2MapBySapPlantReport[];
    groupedCO2MapBySapPlantReportsList: GroupedCO2MapBySapPlantReport[];
}

export class CO2MapBySapPlantReport {
    sapCustomerID: number;
    globalIndustrySegment: string;
    prodHierLevel3: string;
    mtd: number;
    latitude: number;
    longitude: number;
    colour: string;
}

export class GroupedCO2MapBySapPlantReport {
    globalIndustrySegment: string;
    globalIndustrySegmentCount: number;
    totalMTD: number;
}

export class OtherPlantData{
    associtedPlants : PlantData[];
    compPlants : PlantData[];
    bullsEyePlants : BullsEyeData[];
    proposedPlants : ProposedPlantData[];
}

export class PlantData {
    plantCoSite: string;
    company: string;
    province: string;
    lbu: string;
    capacity: number;
    latitude: number;
    longitude: number;
    lbuid: number;
    siteName: string;
    isRealPlant: boolean;
    countryID: string;
}

export class BullsEyeData{
    bullseye: string;
    geoPoint: string;
    dist: number;
}

export class ProposedPlantData {
    plantCoSite: string;
    company: string;
    province: string;
    lbu: string;
    capacity: number;
    lbuid: number;
    siteName: string;
    isRealPlant: boolean;
    countryID: string;
    latitude: number;
    longitude: number;
    miles125: string;
}